module.exports = __webpack_public_path__ + "img/casebanner.6fd739ab.jpg";